import "./css/test.css";
import { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";

const Test = () => {
    const url = process.env.REACT_APP_SERVER_URL;
    const navigate = useNavigate();

    // States
    const [testData, setTestData] = useState([]);
    const [showPaper, setShowPaper] = useState([]);
    const [getType, setGetType] = useState([]);
    const [showYear, setShowYear] = useState([]);
    const [showLanguage, setShowLanguage] = useState([]);
    const [uniqueSeries, setUniqueSeries] = useState([]);
    const [filteredNos, setFilteredNos] = useState([]);
    const [showSeriescode, setShowSeriescode] = useState([]);

    const [showPrevious, setShowPrevious] = useState(false);
    const [showSeries, setShowSeries] = useState(false);
    // FIX: Removed the unused showSubject state to fix the ESLint warning

    // Form selection states
    const [examid, setExamid] = useState("");
    const [paperid, setPaperid] = useState("");
    const [type, setType] = useState("");
    const [language, setLanguage] = useState("");
    const [year, setYear] = useState("");
    const [timer, setTimer] = useState("");
    const [seriesCode, setSeriesCode] = useState("");
    const [seriesno, setSeriesno] = useState("");

    // Initial Fetch (Authentication & Course Validation)
    useEffect(() => {
        const fetchInitialData = async () => {
            const token = localStorage.getItem("token");
            if (!token) {
                alert("Please login to access tests.");
                navigate("/login");
                return;
            }

            try {
                // FIX: Changed to GET request, removed unnecessary body data
                const response = await fetch(`${url}/api/testexam`, {
                    method: "GET",
                    headers: {
                        "Authorization": `Bearer ${token}`,
                    },
                });

                const result = await response.json();
                
                if (!result.status) {
                    if (result.error === "loginError") {
                        alert("Session expired. Please login again.");
                        localStorage.clear();
                        navigate("/login");
                    } else {
                        alert("You are not enrolled in any course. Please enroll first.");
                        navigate("/course");
                    }
                    return;
                }

                if (result.status && result.data) {
                    setTestData(result.data);
                }
            } catch (error) {
                console.error("Error fetching test data:", error);
                alert("Network error. Please try again later.");
            }
        };

        fetchInitialData();
    }, [url, navigate]);

    // Derived unique exams
    const uniqueByExam = [...new Map(testData.map(item => [item.examUniqueid, item])).values()];

    // Handlers
    const handleExamSelect = (selectedExamId) => {
        setExamid(selectedExamId);
        // Reset dependent states
        setPaperid(""); setType(""); setShowPrevious(false); setShowSeries(false);
        
        const filteredArray = testData.filter(item => item.examUniqueid === selectedExamId);
        setShowPaper(filteredArray);
    };

    const handlePaperSelect = async (selectedPaperId) => {
        setPaperid(selectedPaperId);
        // Reset dependent states
        setType(""); setShowPrevious(false); setShowSeries(false);

        if (!selectedPaperId) return;

        try {
            const response = await fetch(`${url}/api/type`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${localStorage.getItem("token")}`,
                },
                body: JSON.stringify({ paperUniqueid: selectedPaperId }),
            });

            const result = await response.json();
            setGetType(result.year || []);
            
            if (result.language) {
                const spliteLanguage = result.language.split("\n").filter(lang => lang.trim() !== "");
                setShowLanguage(spliteLanguage);
            }
        } catch (error) {
            console.error("Error fetching paper details:", error);
        }
    };

    const handleTypeSelect = async (selectedType) => {
        setType(selectedType);
        
        // Reset specific options
        setYear(""); setSeriesCode(""); setSeriesno("");
        setShowPrevious(false); setShowSeries(false);

        if (!selectedType || !paperid) return;

        try {
            const token = localStorage.getItem("token");
            const headers = {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`,
            };

            if (selectedType === "previous") {
                setShowPrevious(true);
                const res = await fetch(`${url}/api/getyear`, {
                    method: "POST", headers, body: JSON.stringify({ paperid })
                });
                const result = await res.json();
                setShowYear(result.year || []);
            } 
            else if (selectedType === "series") {
                setShowSeries(true);
                const res = await fetch(`${url}/api/getseries`, {
                    method: "POST", headers, body: JSON.stringify({ paperid })
                });
                const result = await res.json();
                setShowSeriescode(result.series || []);
                const unique = [...new Set((result.series || []).map(item => item.seriescode))];
                setUniqueSeries(unique);
            } 
            // FIX: Removed the 'subject' block since it was causing the unused variable warning
        } catch (error) {
            console.error(`Error fetching data for type ${selectedType}:`, error);
        }
    };

    const handleSeriesCodeSelect = (selectedCode) => {
        setSeriesCode(selectedCode);
        setSeriesno(""); 
        
        if (selectedCode) {
            const filtered = showSeriescode
                .filter(item => item.seriescode === selectedCode)
                .map(item => item.seriesno);
            setFilteredNos(filtered);
        } else {
            setFilteredNos([]);
        }
    };

    // Generic Validation Function
    const validateSelections = () => {
        if (!examid) return "Please select an Exam.";
        if (!paperid) return "Please select a Paper.";
        if (!type) return "Please select a Type.";
        if (type === "previous" && !year) return "Please select a Year.";
        if (type === "series" && (!seriesCode || !seriesno)) return "Please select both Series Code and Number.";
        if (!language) return "Please select a Language.";
        if (!timer) return "Please select Timer preference.";
        return null;
    };

    // Unified Submit Handler
    const handleSubmit = async () => {
        const errorMsg = validateSelections();
        if (errorMsg) {
            alert(errorMsg);
            return;
        }

        // FIX: Removed unnecessary user info. The backend gets it from the token.
        const data = {
            examid,
            paperid,
            type,
            language,
            timer,
            ...(type === "previous" && { year }),
            ...(type === "series" && { seriesCode, seriesno })
        };

        const endpoint = type === "previous" ? "/api/previouspaper" : "/api/seriesPaper";

        try {
            const response = await fetch(`${url}${endpoint}`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${localStorage.getItem("token")}`,
                },
                body: JSON.stringify(data),
            });

            if (!response.ok) throw new Error("Server failed to process request.");

            const result = await response.json();
            
            // Set required session items before navigating
            sessionStorage.setItem("language", language);
            sessionStorage.setItem("type", type);
            sessionStorage.setItem("timer", timer);
            if (type === "previous") sessionStorage.setItem("year", year);

            navigate("/exam", { state: { paper: result } });

        } catch (error) {
            console.error("Error submitting test preferences:", error);
            alert("Failed to load test. Please try again.");
        }
    };

    return (
        <div className="testPageWrapper">
            <div className="testMainContainer">
                <div className="testImageContainer testBgImage"></div>
                
                <div className="testFormContainer">
                    <div className="testFormHeader">
                        <h2>Start Test</h2>
                        <p>Select your preferences below</p>
                    </div>

                    <div className="testFormContent">
                        
                        {/* Exam Selection */}
                        <div className="testFormGroup">
                            <label className="testFormLabel">Exam</label>
                            <div className="testInputWrapper">
                                <select value={examid} onChange={(e) => handleExamSelect(e.target.value)} className="testSelectField">
                                    <option value="">Select Exam</option>
                                    {uniqueByExam.map((exam, index) => (
                                        <option key={index} value={exam.examUniqueid}>
                                            {exam.exam}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>

                        {/* Paper Selection */}
                        <div className="testFormGroup">
                            <label className="testFormLabel">Paper</label>
                            <div className="testInputWrapper">
                                <select value={paperid} className="testSelectField" onChange={(e) => handlePaperSelect(e.target.value)} disabled={!examid}>
                                    <option value="">Select Paper</option>
                                    {showPaper.map((paper, index) => (
                                        <option key={index} value={paper.paperUniqueid}>
                                            {paper.paper}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>

                        {/* Type Selection */}
                        <div className="testFormGroup">
                            <label className="testFormLabel">Type</label>
                            <div className="testInputWrapper">
                                <select value={type} className="testSelectField" onChange={(e) => handleTypeSelect(e.target.value)} disabled={!paperid}>
                                    <option value="">Select Type</option>
                                    {getType.map((item, index) => (
                                        <option key={index} value={item}>
                                            {item}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>

                        {/* Previous Year Options */}
                        {showPrevious && (
                            <div className="testFormGroup">
                                <label className="testFormLabel">Year</label>
                                <div className="testInputWrapper">
                                    <select value={year} className="testSelectField" onChange={(e) => setYear(e.target.value)}>
                                        <option value="">Select Year</option>
                                        {showYear.map((item, index) => (
                                            <option key={index} value={item.year}>
                                                {item.year}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        )}

                        {/* Series Options */}
                        {showSeries && (
                            <>
                                <div className="testFormGroup">
                                    <label className="testFormLabel">Series Code</label>
                                    <div className="testInputWrapper">
                                        <select value={seriesCode} className="testSelectField" onChange={(e) => handleSeriesCodeSelect(e.target.value)}>
                                            <option value="">Select Code</option>
                                            {uniqueSeries.map((item, index) => (
                                                <option key={index} value={item}>
                                                    {item}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                                
                                <div className="testFormGroup">
                                    <label className="testFormLabel">Series No.</label>
                                    <div className="testInputWrapper">
                                        <select value={seriesno} className="testSelectField" onChange={(e) => setSeriesno(e.target.value)} disabled={!seriesCode}>
                                            <option value="">Select No.</option>
                                            {filteredNos.map((no, index) => (
                                                <option key={index} value={no}>
                                                    {no}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                            </>
                        )}

                        {/* Language Selection */}
                        <div className="testFormGroup">
                            <label className="testFormLabel">Language</label>
                            <div className="testInputWrapper">
                                <select value={language} className="testSelectField" onChange={(e) => setLanguage(e.target.value)} disabled={!paperid}>
                                    <option value="">Select Language</option>
                                    {showLanguage.map((item, index) => (
                                        <option key={index} value={item}>
                                            {item}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>

                        {/* Timer Selection */}
                        <div className="testFormGroup">
                            <label className="testFormLabel">Timer</label>
                            <div className="testInputWrapper">
                                <select value={timer} className="testSelectField" onChange={(e) => setTimer(e.target.value)}>
                                    <option value="">Select Status</option>
                                    <option value="off">OFF</option>
                                    <option value="on">ON</option>
                                </select>
                            </div>
                        </div>

                        {/* Action Buttons */}
                        <div className="testFormActions">
                            <button className="submitTestBtn" onClick={handleSubmit}>Start Exam</button>
                        </div>

                        <div className="testManualLink">
                            <Link to="/footer/manual"><i className="fa-solid fa-circle-info"></i> View Instructions</Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Test;